<template>
  <div class="content">
    <EsForm>
      <template #es-form>
        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">ID Type</label>
          </div>
          <div class="field-body">
            <div class="field is-narrow">
              <div class="control">
                <input class="is-checkradio"
                  id="searchIdTypeLocalCode"
                  type="radio"
                  v-model="idType"
                  value="localCode"
                  name="member">
                <label class="radio"
                  for="searchIdTypeLocalCode">
                  Local Code
                </label>
                <input class="is-checkradio"
                  id="searchIdTypeLocationId"
                  type="radio"
                  v-model="idType"
                  value="locationId"
                  name="member">
                <label class="radio"
                  for="searchIdTypeLocationId">
                  State Location ID
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">ID</label>
          </div>
          <div class="field-body">
            <div class="field">
              <input
                v-if="idType === 'localCode'"
                v-model="id"
                class="input"
                :class="{ 'is-danger': hasErrorId }"
                type="text"
                placeholder="Enter ID"
                v-on:keydown.enter.prevent="formValidation"
                maxlength="40">
              <input
                v-else
                v-model="id"
                class="input"
                :class="{ 'is-danger': hasErrorId }"
                type="text"
                placeholder="Enter ID"
                maxlength="20">
              <p class="help is-danger">{{ idMsg }}</p>
            </div>
          </div>
        </div>
      </template>
    </EsForm>
    <es-form>
      <template #es-form>
        <div class="field is-grouped flex-justify--end">
          <div class="control is-flex flex-align--center">
            <a @click="resetForm">Reset</a>
          </div>
          <div class="control">
            <button
              class="button is-primary"
              @click.stop.prevent="formValidation"
              :disabled="loading"
            >
              Search
            </button>
          </div>
        </div>
      </template>
    </es-form>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';

library.add(faTimes);

export default {
  components: {
    EsForm,
    EsFormActions,
  },
  props: {
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      idType: 'localCode',
      id: null,
      searchSource: 'idSearch',
      hasErrorId: false,
      idMsg: null,
    };
  },
  created() {
    this.checkQuery();
  },
  methods: {
    checkQuery() {
      const { query } = this.$route;
      if (query.searchSource) {
        this.searchSource = query.searchSource;
        this.idType = query.idType;
        this.id = query.id;
      }
    },
    search() {
      const { query } = this.$route;

      if (
        query.idType === this.idType
        && query.id === this.id
      ) {
        return;
      }

      this.$router.push(
        {
          name: 'idSearch',
          query: {
            searchSource: this.searchSource,
            idType: this.idType,
            id: this.id,
          },
        },
      );
    },
    formValidation() {
      this.resetErrors();
      let errors = 0;

      if (!this.id) {
        errors += 1;
        this.idMsg = 'ID is required.';
        this.hasErrorId = true;
      }

      if (errors === 0) {
        this.search();
      }
    },
    resetErrors() {
      this.idMsg = null;
      this.hasErrorId = false;
    },
    resetForm() {
      this.resetErrors();
      this.idType = 'localCode';
      this.id = '';

      if (Object.entries(this.$route.query).length) {
        this.$router.push(
          {
            name: 'idSearch',
          },
        );
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    max-width: 828px
    margin: auto
  .reset
    width: 30px
  li
    border-left: 0 !important
</style>
